import { Pipe, PipeTransform } from '@angular/core';
import { PACKAGE_TYPE } from '../constants';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'packageType'
})
export class PackageTypePipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) {}

  transform(value: string, args?: any): any {
    const key = value || 'other';

    if (Object.keys(PACKAGE_TYPE).indexOf(key) === -1) {
      return '';
    }

    return this.translate.instant(`PACKAGE_TYPES.${key}`);
  }

}
